export default "/_next/static/sounds/UV_LIGHT-b095e2de6c0d2fd552696030d7502dda.mp3";